@use '../../shared-styles' as *;
@use '../../../design-tokens/border-radius/border-radius' as *;
@use '../../../design-tokens/typography/typography' as *;

@layer design-system {
  .rootSvg {
    @include root-svg;
    border-radius: border-radius(r1);
  }

  .axisLine {
    @include axis-line;
  }

  .axisText {
    @include axis-text;
    text-anchor: middle;
  }

  .axisTextHeader {
    text-anchor: end;
  }

  .labelHeader {
    @include typography-v2-body-xs;
    fill: var(--text-default);
  }
}
